"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debugLog = void 0;
const browser_1 = require("./browser");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const debugLog = function () {
  if (!(0, browser_1.isServerSideRendering)()) {
    const params = new URLSearchParams(window.location.search);
    const debugLog = params.get('debugLog') === 'true';
    if (debugLog) {
      console.log(...arguments);
    }
  }
};
exports.debugLog = debugLog;